const DEFAULT_ENABLED_COOPS = ["67360680ce19ea7a7e9bf0ee"]; // Morteros

const parseEnabledCoops = () => {
  const raw = process.env.REACT_APP_RESUMEN_CUENTA_IMPRESION_ENABLED_COOPS;
  if (!raw || !raw.trim()) return DEFAULT_ENABLED_COOPS;

  return raw
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
};

export const isResumenCuentaImpresionEnabledForCoop = (coopId) => {
  if (!coopId) return false;
  const enabledCoops = parseEnabledCoops();
  return enabledCoops.includes(String(coopId));
};

export const getResumenCuentaImpresionEnabledCoops = () => parseEnabledCoops();
